export const RollbarMessages = {
  ERRORS: {},

  WARNINGS: {},

  INFO: {
    UNAUTHORIZED_ACCESS: 'Unauthorized access',
    NOT_AUTHORIZED_TO_PATCH: 'Not authorized to patch the following fields',
    DOES_NOT_HAVE_PERMISSION_TO_ACCESS_STUDENT: 'Does not have permission to access student',
    PLEASE_CONTACT_YOUR_SCHOOL_LEADER: 'Please contact your school leader to request a role change',
  },
};
